import { IPaginationRequest } from "model/Common";
import { EInprocessCheckType } from "model/MasterData";
import { EQualityCheckingConditionType } from "model/QualityCondition";

export interface IInProcessCheck {
  id?: string;
  productId: string;
  productCode: string;
  productName?: string;
  productLot: string;
  numberOfUnit?: number;
  totalQuantity?: number;
  // totalCheckedQuantity?: number;
  // checkingFrom?: string;
  // checkingTo?: string;
  reviewedNote?: string;
  reviewedBy?: string;
  reviewedTime?: string;
  status?: EInProcessCheckStatus;
  qualityCheckingConditionMetadata?: {
    name: string;
    nameEN?: string;
    imageRequired: boolean;
    displayOrder: number;
    type: EQualityCheckingConditionType;
  }[];
  inProcessCheckDetails?: IInProcessCheckDetail[];
  warehouseId?: string;
  createdDate?: string;
  type?: EInprocessCheckType;
  groupDescription?: string;
  totalPerformedQuantity?: number;
  uom?: string;
}

export interface IInProcessCheckDetail {
  id?: string;
  inProcessCheckId: string;
  isLate?: boolean;
  // performedDate: string;
  performedTime: Date;
  performedBy: string;
  qualityCheckingConditions: IQualityConditionInProcessCheckDetail[];
  numberOfUnitFrom: number;
  numberOfUnitTo?: number;
  // checkedDate?: string;
  // checkedTime?: string;
  // checkedBy?: string;
  unitPosition?: EUnitPosition;
}

export interface IQualityConditionInProcessCheckDetail {
  name: string;
  value: string;
  imageUrl?: string;
  prevImageUrl?: string; //additional property for udpate image
  imageRequired?: boolean; //additional property for image required
  nameEN?: string; //additional property for english name
}

export enum EQualityCheckingConditionValue {
  NoUse = -1,
  No,
  Yes,
}

export enum EInProcessCheckStatus {
  New,
  InProcess,
  Checked,
  Reviewed,
}

export interface IGetInProcessCheckRequest
  extends Omit<
    IPaginationRequest,
    "status" | "type" | "isActive" | "warehouseId"
  > {
  productId?: string;
  productLot?: string;
  /**
   * Additional property for display product code on export file
   */
  productCode?: string;
  /**
   * Additional property for display product name on export file
   */
  productName?: string;
  status?: EInProcessCheckStatus;
}

export interface IGetInProcessCheckDetailRequest extends IPaginationRequest {
  inProcessCheckId: string;
}

export interface IReviewInProcessRequest {
  reviewedNote?: string;
}

export enum EUnitPosition {
  HEAD,
  BODY,
  TAIL,
}

export interface IInprocessMessage {
  message?: string;
  title?: string;
  id: string;
  type: string;
}
